<template>
  <section class="prospecting-section">
    <div class="triplea-container">
      <div class="prospecting-main-card">
        <div class="prospecting-main-card-image-bloc">
          <img src="@/assets/img/triplea/home/prospecting-section/prospecting-big-image.png"/>
        </div>
        <div class="prospecting-main-card-content-bloc">
          <div class="prospecting-main-content-texts-box">
            <h2>Apolar Triple A</h2>
            <p>Aqui, redefinimos o modo de viver com excelência. Para nós, viver bem é sobre sentir-se em casa em cada detalhe — com conforto, elegância e experiências que fazem sentido para você. Nosso propósito é conectar você a imóveis que traduzem suas aspirações e elevam sua qualidade de vida.</p>
            <p>Mais do que oferecer imóveis, entregamos cenários únicos, com arquitetura marcante, bem-estar no cotidiano e uma curadoria pensada para quem valoriza o extraordinário em cada escolha.</p>
            <p>Seja bem-vindo!</p>
          </div>
          <div class="prospecting-main-card-content-cards-box">
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/diversification.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Diversificação</h3>
                <p>Descubra novas possibilidades com imóveis de alto padrão que combinam estilos, localizações e propósitos para uma vida além do óbvio.</p>
              </div>
            </div>
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/flexibility.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Flexibilidade</h3>
                <p>Escolha como, onde e quando viver. Nosso portfólio de imóveis premium se adapta ao seu estilo de vida com liberdade e sofisticação.</p>
              </div>
            </div>
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/profitability.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Rentabilidade</h3>
                <p>Invista em imóveis que unem elegância e retorno financeiro. Rentabilidade com segurança, em ativos que valorizam com o tempo.</p>
              </div>
            </div>
            <div class="prospecting-main-card-content-card">
              <div class="prospecting-main-card-content-card-top">
                <img src="@/assets/img/triplea/home/prospecting-section/appreciation.png"/>
              </div>
              <div class="prospecting-main-card-content-card-body">
                <h3>Valorização</h3>
                <p>Imóveis com localização estratégica, arquitetura imponente e alto potencial de crescimento. Um investimento inteligente e duradouro.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import "@/assets/scss/custom/triplea/components/_home_prospecting_section.scss"
  export default {
    
  }
</script>


